<div class="preview-page-modal__carousalModalContainer" *ngFor="let carousal of wholeData; let i = index">
    <app-carousal pageType="previewPage" [carousalData]="carousal"></app-carousal>
</div>
<div class="preview-page-modal__no-data" *ngIf="wholeData.length == 0">
    <div class="preview-page-modal__no-data-content">
        <img class="preview-page-modal__no-data-image" src="../../../assets/images/no-data-icon.png" alt="" />
        <p class="text-body-m">No Data Found</p>
    </div>
</div>
